var render = function render(){var _vm=this,_c=_vm._self._c;return _c('nav',{staticClass:"p-grid p-fluid p-justify-center"},[_c('header',{staticClass:"p-col-12",staticStyle:{"text-align":"center"}},[_c('h1',{style:(_vm.customStyle)},[_vm._t("default",function(){return [_vm._v("m-navigator")]})],2)])])
}
var staticRenderFns = []

export { render, staticRenderFns }